import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  src: {
    default:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
    editor: 'textbox',
  },
  size: {
    default: '40px',
    editor: 'textbox',
  },
  badge: { default: '', editor: 'textbox' },
  badgeAccent: { default: '', editor: 'dropdown', editorOptions: [''].concat(Accents) },
  placeholder: {
    default: 'GS',
    editor: 'textbox',
  },
  avatarStyle: {
    default: '',
    editor: 'multilinetextbox',
  },
};

const PlaygroundKnobs_v3: Knobs = {
  src: {
    default:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
    editor: 'textbox',
  },
  size: {
    default: '40px',
    editor: 'textbox',
  },
  accent: { default: '', editor: 'dropdown', editorOptions: [''].concat(Accents) },
  badge: { default: '', editor: 'textbox' },
  badgeAccent: { default: '', editor: 'dropdown', editorOptions: [''].concat(Accents) },
  placeholder: {
    default: 'GS',
    editor: 'textbox',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
  avatarStyle: {
    default: '',
    editor: 'multilinetextbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'An avatar where you can change all the attributes',
  coreComponent: {
    html: `<tag-avatar {{...knobs}}>
</tag-avatar>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-avatar {{...knobs}}>
</tag3-avatar>`,
    knobs: PlaygroundKnobs_v3,
  },
  reactWrapper: {
    jsx: `<TagAvatar {{...knobs}} />`,
    knobs: {
      ...PlaygroundKnobs,
      avatarStyle: {
        default: '',
        editor: 'multilinetextbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
    },
  },
  reactWrapper_v3: {
    jsx: `<Tag3Avatar {{...knobs}} />`,
    knobs: {
      ...PlaygroundKnobs_v3,
      avatarStyle: {
        default: '',
        editor: 'multilinetextbox',
        qualifierStart: '{',
        qualifierEnd: '}',
      },
    },
  },
};

export const TagAvatarDocs: Component = {
  type: 'component',
  name: 'avatar',
  description: 'Renders an avatar or a placeholder',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'placeholder',
      description: 'placeholder text when there is no image',
      type: 'string',
    },
    {
      name: 'size',
      description: 'Size of the avatar',
      type: 'string',
      default: '40px',
    },
    {
      name: 'src',
      description: 'source of the avatar image',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'V3 Only: The placeholder background-colour',
      type: 'Accent',
    },
    {
      name: 'badge',
      description: 'The badge value to go on the button',
      type: 'string',
    },
    {
      name: 'badgeAccent',
      description: 'The badge colour',
      type: 'string',
      default: 'primary',
    },
    {
      name: 'avatarStyle',
      description: 'A CSS JSON string to apply to the internal element',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
